import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSelector from './LanguageSelector/LanguageSelector';
import './PublicNavbar.css';

const PublicNavbar = () => {
  const { t } = useTranslation();

  return (
    <nav className="public-navbar">
      <div className="public-navbar-container">
        <Link to="/" className="public-navbar-logo">
          Ecom Confirm Bot
        </Link>
        <div className="public-navbar-links">
          <Link to="/" className="public-nav-link">Accueil</Link>
          <Link to="/pricing" className="public-nav-link">Tarifs</Link>
          <LanguageSelector />
          <Link to="/login" className="public-nav-link">Connexion</Link>
          <Link to="/register" className="public-nav-link register-button">S'inscrire</Link>
        </div>
      </div>
    </nav>
  );
};

export default PublicNavbar;
